import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  newStatusId: Yup.string()
    .required("Debes seleccionar el nuevo status"),
  reason: Yup.string()
    .trim()
    .min(10, "El motivo debe tener al menos 10 caracteres")
    .max(500, "El motivo no puede exceder 500 caracteres")
    .required("El motivo es requerido"),
});

const ManualCaseMovementModal = ({
  show,
  onHide,
  caseData,
  statuses,
  onConfirm,
}) => {
  const initialValues = {
    newStatusId: "",
    reason: "",
  };

  const currentStatusName =
    caseData && caseData.caseStatusName
      ? caseData.caseStatusName
      : "Sin status";

  const handleSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      await onConfirm({
        caseId: caseData.id,
        newStatusId: Number(values.newStatusId),
        reason: values.reason.trim(),
      });
    } catch (error) {
      const message =
        error?.response?.data ||
        error?.message ||
        "Ocurrió un error al procesar el movimiento";
      setStatus(typeof message === "string" ? message : JSON.stringify(message));
    } finally {
      setSubmitting(false);
    }
  };

  const availableStatuses = (statuses || []).filter(
    (s) => s.id !== (caseData && caseData.caseStatusId)
  );

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-exchange-alt mr-2"></i>
          Movimiento manual de status
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          status,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              {caseData && (
                <div className="mb-3 p-3 bg-light rounded" style={{ fontSize: "13px" }}>
                  <div>
                    <strong>Folio:</strong> {caseData.caseTicket}
                  </div>
                  <div>
                    <strong>Paciente:</strong>{" "}
                    {[caseData.assuredName, caseData.assuredFlastname, caseData.assuredMlastname]
                      .filter(Boolean)
                      .join(" ")}
                  </div>
                  {caseData.hospitalName && (
                    <div>
                      <strong>Hospital:</strong> {caseData.hospitalName}
                    </div>
                  )}
                </div>
              )}

              <Form.Group controlId="currentStatus">
                <Form.Label>Status actual</Form.Label>
                <Form.Control type="text" value={currentStatusName} readOnly disabled />
              </Form.Group>

              <Form.Group controlId="newStatusId">
                <Form.Label>
                  Nuevo status <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="newStatusId"
                  value={values.newStatusId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.newStatusId && !!errors.newStatusId}
                >
                  <option value="">-- Selecciona un status --</option>
                  {availableStatuses.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.descr || s.status}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.newStatusId}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="reason">
                <Form.Label>
                  Motivo <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="reason"
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.reason && !!errors.reason}
                  placeholder="Describe el motivo del movimiento manual (mínimo 10 caracteres)"
                  maxLength={500}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.reason}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  {values.reason.length}/500
                </Form.Text>
              </Form.Group>

              {status && (
                <div className="alert alert-danger mt-2" role="alert" style={{ fontSize: "13px" }}>
                  {status}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" className="mr-2" />
                    Procesando...
                  </>
                ) : (
                  "Confirmar movimiento"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ManualCaseMovementModal;
